interface CheckoutProgressProps {
  currentStep: 1 | 2 | 3 | 4;
  stepLabel: string;
  /** Total steps (default 4). Use 3 when payment step is skipped (address → shipping → review). */
  totalSteps?: 3 | 4;
}

/** Avoid rendering objects as React children (error #300). */
function safeText(x: unknown): string {
  if (x == null) return "";
  if (typeof x === "string" || typeof x === "number") return String(x);
  return "";
}

export function CheckoutProgress({ currentStep, stepLabel, totalSteps = 4 }: CheckoutProgressProps) {
  const percentage = (currentStep / (totalSteps ?? 4)) * 100;

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-muted-foreground">
          Etapa {currentStep} de {totalSteps} • {safeText(stepLabel)}
        </span>
        <span className="text-xs text-muted-foreground">{Math.round(percentage)}%</span>
      </div>
      <div className="h-2 bg-secondary rounded-full overflow-hidden">
        <div 
          className="h-full bg-primary transition-all duration-300" 
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}